export default "__VITE_ASSET__Btg76awe__"